import React from 'react';

function getInitials(name) {
  return String(name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');
}

function AvatarStack({ names = [], max = 3 }) {
  const visible = names.slice(0, max);
  const overflow = Math.max(0, names.length - visible.length);

  return (
    <div className="flex items-center">
      {visible.map((name, index) => (
        <span
          key={`${name}-${index}`}
          className="inline-flex h-7 w-7 -ml-1.5 first:ml-0 items-center justify-center rounded-full border border-gray-800 bg-axial-700 text-[10px] font-semibold text-white"
          title={name}
        >
          {getInitials(name)}
        </span>
      ))}
      {overflow > 0 && (
        <span className="inline-flex h-7 min-w-7 -ml-1.5 items-center justify-center rounded-full border border-gray-800 bg-gray-700 px-1 text-[10px] font-semibold text-gray-100">
          +{overflow}
        </span>
      )}
    </div>
  );
}

export default AvatarStack;
